import * as S from './styled';

interface DropdownProps {
  options: string[];
  onChange: (idx: number) => void;
}

export function Dropdown({ options, onChange }: DropdownProps) {
  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const idx = options.indexOf(e.target.value);
    onChange(idx);
  };

  return (
    <S.DropdownWrapper>
      <S.Dropdown onChange={handleDropdownChange}>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </S.Dropdown>
    </S.DropdownWrapper>
  );
}
